import React from 'react';
import QRCode from 'react-qr-code';
import { useToast } from '../contexts/ToastContext';
import '../styles/MatchView.css';

function ShareGroupModal({ groupId, label, matchCount, onClose }) {
  const toast = useToast();
  const shareUrl = `${window.location.origin}/group/${groupId}`;

  const handleCopyUrl = async () => {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(shareUrl);
        toast.success('Link copied');
      } else {
        // Fallback for iOS/Safari
        const textArea = document.createElement('textarea');
        textArea.value = shareUrl;
        textArea.style.position = 'fixed';
        textArea.style.opacity = '0';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          document.execCommand('copy');
          toast.success('Link copied');
        } catch (err) {
          toast.error('Couldn’t copy link');
        }
        document.body.removeChild(textArea);
      }
    } catch (err) {
      console.error('Clipboard copy failed', err);
      toast.error('Couldn’t copy link');
    }
  };

  return (
    <div className="share-modal" onClick={onClose}>
      <div className="share-card" onClick={(e) => e.stopPropagation()}>
        <button
          className="close-btn"
          onClick={onClose}
          aria-label="Close"
        >
          ✕
        </button>
        
        <div className="share-card-header">
          <h2 className="share-title">{label}</h2>
          <p className="share-subtitle">Scan to view group • {matchCount} match{matchCount !== 1 ? 'es' : ''}</p>
        </div>
        
        <div className="share-qr-wrapper">
          <QRCode 
            value={shareUrl} 
            size={200}
            style={{ padding: '1rem', background: 'white', borderRadius: '12px' }}
          />
        </div>
        
        <button
          className="share-copy-btn"
          onClick={handleCopyUrl}
        >
          Copy Link
        </button>
      </div>
    </div>
  );
}

export default ShareGroupModal;

